export default {
  title: 'How does your client plan to use the loan?'
};
